export const createFeatureCollection = (features) => ({
  type: 'FeatureCollection',
  features
})

export const createFeature = (geometry, properties, options) => ({
  type: 'Feature',
  geometry,
  properties,
  options
})

export const createPoint = (coordinates, properties, options) => createFeature(
  {
    type: 'Point',
    coordinates
  },
  properties,
  options
)

export const createPolygon = (coordinates, properties, options) => createFeature(
  {
    type: 'Polygon',
    coordinates
  },
  properties,
  options
)
